import React from 'react';

const IVSContext = React.createContext();

export default IVSContext;